export class ReportParameters {
  constructor({
    startDate = null,
    endDate = null,
    showRejected = true,
    email = null
  } = {}) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.showRejected = showRejected;
    this.email = email;
  }
}
export function createReportParameters(data) {
  return Object.freeze(new ReportParameters(data));
}
